<template>
  <sidebar title="Last Activity" class="last-activity-sidebar">

    <ul ref="contentWrapper" @scroll="setHasMoreOverflow">
      <last-activity-item v-for="(item, index) in lastActivitiesData"
                          :key="`last-activity-item-${index}`"
                          :item="item"
                          :resource-name="resourceName" />
      <li v-if="!isInitiated && isBusy" class="inner-loader text-center">
        <i class="far fa-spinner-third fa-spin" />
      </li>
      <div ref="observerBottomTarget"></div>
    </ul>

    <div v-if="isInitiated && isBusy" class="text-center">
      <loader-inline class="gray sm" />
    </div>
    <div v-else-if="showMoreButton" class="hasMore">
      <i class="fas fa-chevron-down link-pointer" @click="scrollDown"/>
    </div>
  </sidebar>
</template>

<script>

// Plugins
import { mapState, mapActions } from 'vuex'

// Mixins
import infiniteLoad from "../../../mixins/boolean-search/infiniteLoad";

// Components
import sidebar from '../../sidebar.vue';
import lastActivityItem from './components/LastActivityItem.vue'
import loaderInline from '../../loader-inline.vue'

export default {
  name: "last-activity-sidebar",

  props: {
    resourceName: {
      type: String,
      required: true
    }
  },

  mixins: [ infiniteLoad ],

  mounted() {
    const queryId = this.resourceId ? `/${this.resourceId}` : '';
    const groupType = this.resourceType === 'group' ? `/group_library` : this.resourceType === 'tag_library' ? `/tag_library` : '';
    const url = `projects/${this.project_id}/searches${groupType}/history${queryId}`;

    this.initInfiniteLoad('last_activities', this.$refs.observerBottomTarget, 'canLoadMore', url);
  },

  data() {
    return {
      showMoreButton: false
    }
  },

  computed: {
    ...mapState({
      isResizing: state => state.booleanSearch.isResizing,
      lastActivitiesObject: state => state.booleanSearch.last_activities
    }),
    lastActivitiesData() { return this.lastActivitiesObject.data },
    pagination() { return this.lastActivitiesObject.pagination },
    isInitiated() { return this.lastActivitiesObject.isInitiated },
    isBusy() { return this.lastActivitiesObject.isBusy },
    canLoadMore() {
      return this.isInitiated && !this.isBusy && this.pagination.page && this.pagination.page < this.pagination.total_pages },
    resourceType() {
      return this.resourceName === 'group_library' ? 'group' : this.resourceName === 'searches' ? 'search' : this.resourceName;
    },
    resourceId () {
      return this.$route.params.group_id || this.$route.params.search_id;
    }
  },

  methods: {
    ...mapActions({
      getPaginatedResource: 'booleanSearch/getPaginatedResource',
    }),

    setHasMoreOverflow() {
      this.showMoreButton = this.isOverFlown(this.$refs.contentWrapper)
    },
    isOverFlown(e) {
      return (e.scrollTop + e.clientHeight < e.scrollHeight);
    },

    scrollDown() {
      let listComponent = this.$refs.contentWrapper;
      let scrollTop = listComponent.scrollTop + listComponent.clientHeight;
      if(scrollTop + listComponent.clientHeight > listComponent.scrollHeight) {
        scrollTop = listComponent.scrollHeight;
      }

      listComponent.scrollTop = scrollTop;
    }
  },

  watch: {
    isResizing(newVal) { // check showMore button on resize
      if(newVal) this.setHasMoreOverflow()
    },
    isBusy: {
      handler (newVal, oldVal) {
        if(oldVal === true && newVal === false) {
          this.setHasMoreOverflow();
        }
      }
    }
  },

  components: {
    sidebar,
    lastActivityItem,
    loaderInline,
  }
}
</script>